(function ($) {
    $('.page-anchor').click(function (e) {
        e.preventDefault();
        e.stopPropagation();
        $('html, body').animate({
            scrollTop: $($(this).attr('href')).offset().top,
        }, 600);
    });
}(jQuery));
